import React, { useState } from 'react';
import SleekExplainField from './SleekExplainField';

const FormerFederalService: React.FC = () => {
  const [hasActions, setHasActions] = useState<string>('');
  const [whyLeave, setWhyLeave] = useState<string>('');
  const [anotherPeriod, setAnotherPeriod] = useState<string>('');
  const [showExplanation, setShowExplanation] = useState<boolean>(false);

  const handleActionsChange = (value: string) => {
    setHasActions(value);
    if (value === 'unknown') {
      setShowExplanation(true);
    } else {
      setShowExplanation(false);
    }
  };

  return (
    <div className="flex-1 p-8 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <div className="mb-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Former federal service</h2>
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <p className="text-sm text-blue-800">
                <strong>Former Service:</strong> Provide federal service history
              </p>
            </div>
          </div>

          <div className="space-y-8">
            {/* Disciplinary Actions Question */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Did you receive any disciplinary actions during this employment? (Examples 
                of disciplinary actions include: recommendations, written warnings, official 
                reprimands, official counseling, and suspensions.) 
                <span className="text-blue-600 ml-2 cursor-help" title="Help information">ℹ️</span>
              </h3>
              <div className="space-y-2">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="disciplinaryActions"
                    value="yes"
                    checked={hasActions === 'yes'}
                    onChange={(e) => handleActionsChange(e.target.value)}
                    className="h-4 w-4 text-gov-blue focus:ring-gov-blue border-gray-300"
                  />
                  <span className="ml-2 text-sm text-gray-700">Yes</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="disciplinaryActions"
                    value="no"
                    checked={hasActions === 'no'}
                    onChange={(e) => handleActionsChange(e.target.value)}
                    className="h-4 w-4 text-gov-blue focus:ring-gov-blue border-gray-300"
                  />
                  <span className="ml-2 text-sm text-gray-700">No</span>
                </label>
              </div>
            </div>

            {/* Why Leave Question */}
            <div>
              <SleekExplainField
                label="Why did you leave this Federal employment?"
                placeholder="Please provide details about your departure from federal employment..."
                helpText="Use the AI Assistant to help provide a comprehensive explanation for why you left your federal employment."
                value={whyLeave}
                onChange={setWhyLeave}
                fieldType="federal-service-departure"
              />
            </div>

            {/* Another Period Question */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Do you have another period of federal employment with this federal agency 
                or expect?
              </h3>
              <div className="space-y-2">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="anotherPeriod"
                    value="yes"
                    checked={anotherPeriod === 'yes'}
                    onChange={(e) => setAnotherPeriod(e.target.value)}
                    className="h-4 w-4 text-gov-blue focus:ring-gov-blue border-gray-300"
                  />
                  <span className="ml-2 text-sm text-gray-700">Yes</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="anotherPeriod"
                    value="no"
                    checked={anotherPeriod === 'no'}
                    onChange={(e) => setAnotherPeriod(e.target.value)}
                    className="h-4 w-4 text-gov-blue focus:ring-gov-blue border-gray-300"
                />
                  <span className="ml-2 text-sm text-gray-700">No</span>
                </label>
              </div>
            </div>

            {/* Federal Employment To Report Question */}
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-4">
                Do you have another period of federal employment to report?
              </h3>
              <div className="space-y-2">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="reportAnother"
                    value="yes"
                    className="h-4 w-4 text-gov-blue focus:ring-gov-blue border-gray-300"
                  />
                  <span className="ml-2 text-sm text-gray-700">Yes</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="reportAnother"
                    value="no"
                    className="h-4 w-4 text-gov-blue focus:ring-gov-blue border-gray-300"
                  />
                  <span className="ml-2 text-sm text-gray-700">No</span>
                </label>
              </div>
            </div>

            {/* Explanation Field with AI Assist */}
            {showExplanation && (
              <SleekExplainField
                label="Please explain:"
                placeholder="Please provide additional details about the disciplinary actions..."
                helpText="Use the AI Assistant to help provide a comprehensive explanation about your disciplinary actions."
                fieldType="federal-service-disciplinary"
              />
            )}
          </div>

          {/* Action Buttons */}
          <div className="mt-8 pt-6 border-t border-gray-200 flex justify-between">
            <button className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50">
              Previous
            </button>
            <div className="space-x-3">
              <button className="px-6 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200">
                Save Progress
              </button>
              <button className="px-6 py-2 bg-gov-blue text-white rounded-md hover:bg-blue-800">
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormerFederalService;